import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { noop } from 'utils/noop';
import Droppable from './Droppable';
import Draggable from './Draggable';

// type props = {
//   /** Must be ```<DragAndDropList.Droppable>``` */
//   children: node,
//   /**
//    * Function when moving an item from one list to another list.
//    *
//    * ```
//    * onMove(itemIndex, newIndex, listId)
//    * ```
//    * @param { Number } sourceIndex: The index of the item being moved.
//    * @param { String } sourceListId: The id of the list to move the item from.
//    * @param { Number } destinationIndex: The new index of the item to move to.
//    * @param { String } destinationListId: The id of the list to move the item to.
//    * @returns { void }
//    */
//   onMove: (
//     sourceIndex: number,
//     sourceListId: string,
//     destinationIndex: number,
//     destinationListId: string,
//   ) => void,
//   /**
//    * Function when reordering items of one list.
//    *
//    * ```
//    * onReorder(itemIndex, newIndex, listId)
//    * ```
//    * @param { Number } itemIndex: The index of the item being moved.
//    * @param { Number } newIndex: The new index of the item to move to.
//    * @returns { void }
//    */
//   onReorder: (itemIndex: number, newIndex: number, listId: string) => void,
// };

/**
 * Simple wrapper for [react-beautiful-dnd](https://github.com/atlassian/react-beautiful-dnd). Provides
 * shortcuts to apply provider and snapshot to droppable and draggable items. Simplifies the styles to
 * use classes instead.
 */

export default class DragAndDropList extends React.Component {
  static Droppable = Droppable;
  static Draggable = Draggable;

  static defaultProps = {
    onMove: noop,
    onReorder: noop,
  };

  /**
   * Callback function on drag end. Determines if move or reorder has occurred.
   * @param { Object } result: The new state and ordering of items.
   * @returns { void }
   */
  handleDragEnd = (result) => {
    const { onMove, onReorder } = this.props;
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      onReorder(source.index, destination.index, source.droppableId);
    } else {
      onMove(source.index, source.droppableId, destination.index, destination.droppableId);
    }
  };

  render() {
    const { children } = this.props;
    return <DragDropContext onDragEnd={this.handleDragEnd}>{children}</DragDropContext>;
  }
}
